import { vehicleNumberScheme } from '@sravni/cosago-react-library/lib/validationSchemes';

import { isBrandValid, isAutoModelValid, mapBrand, mapAutoModel, mapAutoYear } from 'shared/lib/mapDictionaries';
import type { TAutoInfo } from 'shared/types';

import type { TPledgeAutoFields } from 'entities/pledgeAutoForm';

import { mapPower } from './mapPowers';

/**
 * Так как в дизайн системе undefined не обновляет значение поля,
 * следует использовать пустые строки вместо undefined
 * */
// eslint-disable-next-line complexity
export const mapAutoInfoToPledgeAutoFields = (info: TAutoInfo): Nullable<TPledgeAutoFields> => {
  if (!info) return null;

  const { carNumber, brand, model, year, power, isTaxi } = info;

  const carNumberValidated = carNumber && vehicleNumberScheme().isValidSync(carNumber) ? carNumber : '';

  const carBrand = (isBrandValid(brand)
    ? {
        ...mapBrand(brand),
        data: {
          ...mapBrand(brand).data,
          isPrefilled: true,
        },
      }
    : { value: '' }) as unknown as TPledgeAutoFields['carBrand'];

  const carModel = (brand?.id && isAutoModelValid(model)
    ? { ...mapAutoModel(model), data: { ...mapAutoModel(model).data, isPrefilled: true } }
    : { value: '', data: { categories: [] } }) as unknown as TPledgeAutoFields['carModel'];

  const carManufactureYear =
    brand?.id && model?.id && year ? { ...mapAutoYear(year), data: { isPrefilled: true } } : { value: '' };

  const enginePower =
    brand?.id && model?.id && year && power ? { ...mapPower(power), data: { isPrefilled: true } } : { value: '' };

  return {
    carBrand,
    carModel,
    carManufactureYear,
    enginePower,
    carNumber: carNumberValidated,
    isTaxi: isTaxi ?? false,
  };
};
